import { RootState } from '../store';

export const selectReportDateRange = (state: RootState) =>
  state.memberReporting.dateRange;
